import "../../Styles/home.css";
import Banner from "../../Assets/nursing-students.jpg";
const HomePage = () => {
  return (
    <>
      <div className="banner">
        <img src={Banner} alt="Nursing students banner" />
        <div className="overlay">
          <h2 className="hero-title"> ANNOUNCEMENTS</h2>
          <div className="marquee-container">
            {/* <p className="herocontent"> */}
            {/* No new announcements. */}
            {/* EXAM FORMS FOR ANM1, ANM2, GNM1, GNM2 & GNM3 MAIN EXAM{" "} */}
            {/* <span className="label">New</span> */}
            {/* </p> */}
            <p className="herocontent">
              EXAM RESULT FOR GNM1 MAIN EXAM <span className="label">New</span>
            </p>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="table-container">
          <h2 className="section-title">Latest Information</h2>
          <table className="info-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Link</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>EXAM RESULT FOR GNM1 MAIN EXAM</td>
                <td>14-OCT-2026</td>
                <td>16-OCT-2026</td>
                <td>
                  <a
                    href="https://result.mpnrconline.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Click Here
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="login-container">
          <h2 className="section-title">Logins</h2>
          <div className="buttons">
            <div className="exam-form">
              <h3>For Enrolment - Year 2022-23</h3>
              {/* <div className='line-separate'></div> */}
              {/* <button
                className="home-buttons"
                onClick={() =>
                  window.open("https://result.mpnrconline.org/", "_blank")
                }
              >
                Result
              </button> */}
              <button
                className="home-buttons"
                onClick={() =>
                  window.open(
                    "https://exam.mpnrconline.org/studentLogin",
                    "_blank",
                  )
                }
              >
                College Login
              </button>
              <button
                className="home-buttons"
                onClick={() =>
                  window.open("https://result.mpnrconline.org/", "_blank")
                }
              >
                Result
              </button>
              {/* <button className="home-buttons disabled-link" disabled>
                Registration For Shifting
              </button> */}
            </div>

            {/* <div className='enrolment'> */}
            {/* <h3>For Enrolment</h3> */}
            {/* <div className='line-separate'></div> */}
            {/* <a href="https://examreg.mpnrconline.org/Admin/?Type=College" className='home-buttons' target="_blank" rel="noopener noreferrer">College Login</a> */}
            {/* <a className='home-buttons disabled-link' onClick={(e) => e.preventDefault()}>College Login</a> */}
            {/* <a href="https://examreg.mpnrconline.org/Admin/?Type=Counsellor" className='home-buttons' target="_blank" rel="noopener noreferrer">Counsellor login</a> */}
            {/* <a className='home-buttons disabled-link' onClick={(e) => e.preventDefault()}>Counsellor login</a> */}
            {/* </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
